import script from "./CashBackTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./CashBackTip.vue?vue&type=script&setup=true&lang=ts"

import "./CashBackTip.vue?vue&type=style&index=0&id=3d47a6d0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d47a6d0"]])

export default __exports__